export default __webpack_public_path__ + "static/media/tick.inline.289279c1.svg";